import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { UploadCloud } from "react-feather";

import { filterInternalAttachments } from "../../../../utils/internalAttachments";

import "./internal-attachments.scss";

/** Área de arrastar e soltar do chat interno.
 *  O `onDragOver` com preventDefault precisa cobrir toda a janela — inclusive com o
 *  preview aberto. Sem ele, o navegador abre o arquivo solto e derruba a SPA.
 */
const InternalDroppableFiles = ({ children, disabled, onSelectFiles, onErrors, className }) => {
    const intl = useIntl();
    const [showDropZone, setShowDropZone] = useState(false);

    const handleOnDragEnter = (e) => {
        e.preventDefault();
        if (!disabled) setShowDropZone(true);
    }

    const handleOnDragLeave = (e) => {
        e.preventDefault();
        setShowDropZone(false);
    }

    const handleOnDrop = useCallback((e) => {
        setShowDropZone(false);
        if (disabled) return;

        const droppedFiles = Array.from(e.dataTransfer.files || []);
        if (droppedFiles.length === 0) return;

        const { acceptedFiles, errors } = filterInternalAttachments(droppedFiles);
        if (onErrors) onErrors(errors);
        if (acceptedFiles.length > 0) onSelectFiles(acceptedFiles);
    }, [disabled, onSelectFiles, onErrors]);

    return (
        // O preventDefault NÃO pode depender de `disabled`: sem ele o navegador trata o
        // drop como navegação, abre o arquivo e derruba a SPA. Sem permissão de anexo o
        // drop é engolido — nunca liberado para o navegador.
        <div
            className={`internal-droppable-files-ui ${className || ""}`}
            onDragEnter={handleOnDragEnter}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => { e.preventDefault(); handleOnDrop(e); }}
        >
            {!disabled && showDropZone && (
                <>
                    {/* Camada acima de tudo só para capturar o dragleave: sem ela, passar o
                        cursor sobre um filho dispara dragleave e a zona pisca. */}
                    <div
                        onDragLeave={handleOnDragLeave}
                        onMouseLeave={handleOnDragLeave}
                        className="internal-droppable-files-catcher"
                    />
                    <div className="internal-droppable-files-zone">
                        <div className="internal-droppable-files-zone-border">
                            <UploadCloud size={32} />
                            <p>{intl.formatMessage({ id: "Arraste e solte o arquivo aqui" })}</p>
                        </div>
                    </div>
                </>
            )}
            {children}
        </div>
    );
}

export default InternalDroppableFiles;
